import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=1fee9a60&scoped=true&"
var script = {}
import style0 from "./tile.vue?vue&type=style&index=0&id=1fee9a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee9a60",
  null
  
)

export default component.exports